import { useState } from "react";

export default function SupplierForm({ onSubmit, initialValues }) {
  const [form, setForm] = useState({
    name: initialValues?.name || "",
    contact_person: initialValues?.contact_person || "",
    email: initialValues?.email || "",
    phone: initialValues?.phone || "",
  });
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await onSubmit(form);
    } catch (err) {
      setError(err.message || "Fout bij aanmaken leverancier");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {error && <p className="text-red-600">{error}</p>}

      <div>
        <label className="block font-medium mb-1">Naam</label>
        <input
          name="name"
          className="border rounded p-2 w-full"
          value={form.name}
          onChange={handleChange}
          required
        />
      </div>

      <div>
        <label className="block font-medium mb-1">Contactpersoon</label>
        <input
          name="contact_person"
          className="border rounded p-2 w-full"
          value={form.contact_person}
          onChange={handleChange}
        />
      </div>

      <div>
        <label className="block font-medium mb-1">E-mail</label>
        <input
          name="email"
          type="email"
          className="border rounded p-2 w-full"
          value={form.email}
          onChange={handleChange}
        />
      </div>

      <div>
        <label className="block font-medium mb-1">Telefoon</label>
        <input
          name="phone"
          className="border rounded p-2 w-full"
          value={form.phone}
          onChange={handleChange}
        />
      </div>

      <button
        type="submit"
        className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
      >
        Opslaan
      </button>
    </form>
  );
}
